import { get, post } from '@/utils/apiBase.js';
// 获取和家亲三方access_token
const getThirdAccessToken = (option, headers) => {
  return get('/apis/account/get_third_access_token', option, headers);
};
// 三方授权信息
const postThirdOAuth = (option, headers) => {
  return post('/account/third_oauth', option, headers);
};
// 三方验证登录
const postThirdLogin = (option, headers) => {
  return post('/account/third_login', option, headers);
};
export default {
    getThirdAccessToken,
    postThirdOAuth,
    postThirdLogin
};
